export default __webpack_public_path__ + "static/media/protergia_ΗΛ.c0717735.png";